var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('vxe-grid',{ref:"table",attrs:{"size":"mini","resizable":"","auto-resize":"","highlight-hover-row":"","data":_vm.tableData,"columns":_vm.tableColumns,"loading":_vm.loading,"height":_vm.height},scopedSlots:_vm._u([{key:"modifyInfo",fn:function(ref){
var row = ref.row;
return [_c('span',[_vm._v(_vm._s(row.updateByName))]),_c('br'),_c('span',[_vm._v(_vm._s(row.updateTime))])]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }